import React from "react";
import styled from "styled-components";
import logo from "../assets/logo.png";

const LogoContainer = styled.div`
  display: inline-block;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
  }
`;

const LogoImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
  transition: all 0.2s ease;
  border-radius: 20px;
  background-color: ${(props) => props.theme.body};
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 64em) {
    width: 50px;
    height: 50px;
    border-radius: 16px;
    padding: 3px;
  }

  @media (max-width: 48em) {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    padding: 2px;
  }

  @media (max-width: 30em) {
    width: 35px;
    height: 35px;
    border-radius: 10px;
    padding: 2px;
  }
`;

const Logo = () => {
  const handleClick = () => {
    window.open("https://x.com/RealNadsClub", "_blank", "noopener,noreferrer");
  };

  return (
    <LogoContainer onClick={handleClick}>
      <LogoImage src={logo} alt="RealNads Logo" />
    </LogoContainer>
  );
};

export default Logo;
